import { useGetUserPermissions } from 'api/profile/useGetUserPermissions/useGetUserPermissions';
import LoginPage from 'pages/LoginPage/LoginPage';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';

import SplashScreen from '../SplashScreen';

const PrivateLogin = () => {
  const [{ token }] = useCookies(['token']);
  const { getUserPermissions, userPermissionsloading } =
    useGetUserPermissions();

  useEffect(() => {
    if (token) {
      getUserPermissions();
    }
  }, [token]);

  return userPermissionsloading ? (
    <SplashScreen />
  ) : token ? (
    <Navigate to="/" />
  ) : (
    <LoginPage />
  );
};

export default PrivateLogin;
